import { GhostContentAPIOptions } from '@tryghost/content-api';

export const TASKS_CODES = {
  SET_PROFILE: '1',
  CUSTOMIZE_PORTAL: '2',
  DESIGN_LANDING_PAGE: '3',
  LINK_LANDING: '4',
  CONNECT_CUSTOM_DOMAIN: '5',
  CONNECT_BANK_ACCOUNT: '6',
  SETUP_PAYMENT_METHOD: '7',
  INVITE_TEAM: '8',
  FIRST_CLIENT: '9',
  READ_PORTAL_GUIDE: '10',
  VERIFY_EMAIL: '11',
};

// this map set defines only the tasks that should be
// shown in ftux v2
export const FTUX_V2_TASKS = {
  [TASKS_CODES.CUSTOMIZE_PORTAL]: true,
  [TASKS_CODES.FIRST_CLIENT]: true,
  [TASKS_CODES.VERIFY_EMAIL]: true,
};

export const GhostAPIOptions: GhostContentAPIOptions = {
  url: 'https://www.joinportal.com/updates',
  key: 'e6cf9196e67655b1dd83661527',
  version: 'v3',
};
